require('../../modules/es6.number.epsilon');
module.exports = Math.pow(2, -52);



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/number/epsilon.js
// module id = 1457
// module chunks = 0